import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Paper, Typography, IconButton, Box, Dialog, DialogTitle, DialogContent, Button, DialogActions,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

import TableFiles from './table';
import { useDataProvider, useTranslate } from 'react-admin';
import { baseAuthUrl } from '../authProvider';
import Snackbar from '../common/snackbar';
import SearchGroup from './search-group';
import Breadcrumbs from './file-breadcrumbs';
import RootContent from './root-content';
import FormCreateFolderOnly from './form-create-folder-only';
import { sortCategories } from '../utils';
import { useDispatch, useSelector } from 'react-redux';
import { isBlockingInfoChannel } from '../infochannels/action';
import { changeCategory, changeSelectedItems } from '../redux/actions/file-manager-actions';
import icSupport from '../assets/icons/ic_support_grey.png';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles((theme) => ({
    formControlLabel: {
        marginTop: theme.spacing(1),
    },
    dialog: {
        // height: '90vh',
        overflow: 'hidden',
        backgroundColor: '#f3f7fa',
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: theme.spacing(6)
    },
    dialogRoot: {
        backgroundColor: '#f3f7fa',
        paddingBottom: theme.spacing(6)
    },
    searchGroup: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(2)
    },
    backButton: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 5,
    },
    backIcon: {
        width: 15,
        height: 15
    },
    Tittle: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "18px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
    },
    TittleSmall: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: "500",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: '#88898c'
    },
    btnClose: {
        fontFamily: "UniviaPro-Bold",
        fontSize: "10px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: '0.4px',
    },
    borderClose: {
        borderRadius: "10px",
        border: "solid 2px #e5f1f8",
        backgroundColor: " #ffffff",
    },
    textNoPermission: {
        fontFamily: 'UniviaPro-Book',
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '15px',
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.87)',
        paddingTop: '10px'
    },
}));

let children = [];
export default function MaxWidthDialog({ isSetPath, formats, setOnlyUrl, setChooseValue, defaultId, setCategoryDefaultId, open, handleClose, pickerMode, isPermission }) {
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const { category, selectedItems } = useSelector(state => state.file_manager);

    const [loading, setLoading] = useState(false);
    const [openPickError, setOpenPickError] = useState(false)
    const [searchEmpty, setSearchEmpty] = useState(false);
    const [timeoutDelete, setTimeoutDelete] = useState({
        timeoutId: null,
        ids: []
    });
    const [msgCopyOrMoveSnackbar, setMsgCopyOrMoveSnackbar] = useState({
        message: '',
        boldText: ''
    });
    const [hasPermission, setHasPermission] = useState(false)

    const chooseFile = () => {
        dispatch(isBlockingInfoChannel(true))
        if (pickerMode === 'pickMediaOnly') {
            if (isSetPath) {
                let obj = category.categories.find(value => value.checked)
                setChooseValue(JSON.stringify({
                    id: obj.id,
                    fd: obj.fd,
                    filepath: category.name + '/' + obj.name
                }))
            }
            else
                setChooseValue(
                    !setOnlyUrl ? category.categories.find(value => value.type !== "Folder" && value.checked) : category.categories.find(value => value.checked).fd
                )
            handleClose()
        }
        else if (pickerMode === 'pickMedia') {
            setChooseValue(
                category.categories.filter(value => value.checked)
            )
            handleClose()

        }
    }

    function onBackClick() {
        const { path } = category;
        if (path.length === 1) {
            handleClose();
        } else {
            const { id } = path[path.length - 2];
            getCategory(id);
            setSearchEmpty(false)
        }
    }

    const getCategory = (id, callback) => {
        setLoading(true);
        dataProvider('GET_LIST', 'categories', {
            filter: { id },
            pagination: {},
            sort: {}
        }).then(({ data }) => {
            if (callback) {
                // Fake delete
                data.categories = callback(data.categories);
            }
            var temps = data
            if (formats) {
                let categories = data.categories.filter(item => formats(item.type) || item.type === 'Folder')
                temps.categories = categories
            }
            temps.categories.forEach(item => {
                item.checked = false;
            });
            children = temps.categories.map(item => item);
            dispatch(changeCategory(temps));
            setLoading(false);
            if (setCategoryDefaultId) {
                setCategoryDefaultId(data.id);
            }
        }).catch(error => {
            if (error.message === 'permissionIncorect')
                setHasPermission(true)
            console.error('Get list error:', error);
        });

        if (selectedItems.length > 0) {
            dispatch(changeSelectedItems([]));
        }
    }

    const onFilter = (text) => {
        const newChildren = children.filter(child => child.name.toLowerCase().includes(text.trim().toLowerCase()));
        const newCategory = {
            ...category,
            categories: newChildren
        };
        dispatch(changeCategory(newCategory));
        if (newCategory.categories.length === 0) {
            setSearchEmpty(true)
        } else {
            setSearchEmpty(false)
        }
    }

    const onCheck = (id) => {
        const categories = category.categories.map(item => ({
            ...item,
            checked: item.id === id ? !item.checked : pickerMode === 'pickMediaOnly' ? false : item.checked
        }));
        dispatch(changeCategory({
            ...category,
            categories
        }));
        // if (!pickerMode) {
        //     const newSelectedItems = categories.filter(item => item.checked);
        //     dispatch(changeSelectedItems(newSelectedItems));
        // }
        if (pickerMode === 'menu') {
            const newSelectedItems = categories.filter(item => item.checked);
            dispatch(changeSelectedItems(newSelectedItems));
        }
    }

    const executeDelete = (ids) => {
        setTimeoutDelete({
            timeoutId: null,
            ids: []
        });
        ids.forEach(id => {
            dataProvider('DELETE', 'category', { id }).then((data) => {
            }).catch(error => {
                console.log('Submit user error:', error);
            });
        });
    }

    const onDelete = (ids = []) => {
        const newCategories = categories.filter((item) => ids.indexOf(item.id) === -1);
        dispatch(changeCategory({
            ...category,
            categories: newCategories
        }));

        if (timeoutDelete.timeoutId) {
            executeDelete(timeoutDelete.ids);
            clearTimeout(timeoutDelete.timeoutId);
        }

        const timeoutId = setTimeout(() => {
            executeDelete(ids);
        }, 6000);
        setTimeoutDelete({ timeoutId, ids });
    }

    const onUndoDelete = () => {
        setTimeoutDelete({ timeoutId: null, ids: [] });
        getCategory(category.id);
        clearTimeout(timeoutDelete.timeoutId);
    }

    const onClear = () => {

        const categories = category.categories.map(item => ({
            ...item,
            checked: false
        }));
        dispatch(changeCategory({
            ...category,
            categories
        }));
        dispatch(changeSelectedItems([]));
    }

    const onDownload = () => {
        const selectedItems = category.categories.filter(item => item.checked);
        let params = '?';
        selectedItems.forEach(item => {
            params += 'ids=' + item.id + '&'
        });
        window.open(`${baseAuthUrl}/category/multi-download/${params}`);

        const categories = category.categories.map(item => ({
            ...item,
            checked: false
        }));
        dispatch(changeCategory({
            ...category,
            categories
        }));
        dispatch(changeSelectedItems([]));
    }

    const onSortable = (nextSort) => {
        const newCategories = sortCategories(category.categories, nextSort.field, nextSort.order);
        dispatch(changeCategory({
            ...category,
            categories: newCategories
        }));
    }

    const onEnter = () => {
        getCategory(defaultId);
    }

    useEffect(() => {
        getCategory(defaultId);
    }, []);

    useEffect(() => {
        if (timeoutDelete.timeoutId !== null) {
            executeDelete(timeoutDelete.ids);
            setTimeoutDelete({ timeoutId: null, ids: [] });
        }
    }, [category.id])

    const categories = category.categories ? category.categories : [];
    if (!open) return null;
    return (
        <Dialog
            onEnter={onEnter}
            fullWidth={true}
            maxWidth={category.level === -1 ? 'md' : 'sm'}
            open={open}
            onClose={handleClose}
            aria-labelledby="max-width-dialog-title"
            disableEnforceFocus
        >
            {
                category.level === 1 ? (
                    <Paper className={classes.dialogRoot}>
                        <DialogTitle disableTypography id="max-width-dialog-title" style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 0 }}>
                            <Box display='flex' justifyContent='flex-end' alignItems='center' marginLeft="auto">
                                <Typography className={classes.btnClose}>{translate('pos.common.close')}</Typography>
                                <CloseButton onClick={handleClose}/>
                            </Box>

                        </DialogTitle>
                        <DialogContent style={{ paddingLeft: 36, paddingRight: 36 }}>
                            <RootContent category={category} getCategory={getCategory} />
                        </DialogContent>
                    </Paper>
                ) : (
                        <Paper className={classes.dialog}>
                            <DialogTitle disableTypography id="max-width-dialog-title" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                {
                                    category.level !== 1 &&
                                    <Breadcrumbs
                                        path={category && category.path}
                                        onBackClick={onBackClick}
                                        getCategory={getCategory}
                                        setSearchEmpty={setSearchEmpty}
                                    />
                                }
                                <Box display='flex' justifyContent='flex-end' alignItems='center' marginLeft="auto">
                                    <Typography className={classes.btnClose}>{translate('pos.common.close')}</Typography>
                                    <CloseButton onClick={handleClose}/>
                                </Box>

                            </DialogTitle>
                            <DialogContent style={{ paddingLeft: 36, paddingRight: 36 }}>
                                {
                                    category.level === 2 ? (
                                        <FormCreateFolderOnly
                                            permission={isPermission}
                                            pickerMode={pickerMode}
                                            name={category.name}
                                            categoryId={category.id}
                                            getCategory={getCategory}
                                            setSnackbarMessage={setMsgCopyOrMoveSnackbar} />
                                    ) : (
                                            <Box hidden={hasPermission === true}>
                                                <Fragment>
                                                    <Box display="flex" alignItems="center">
                                                        <Typography className={classes.Tittle}>{category.name}</Typography>
                                                        <Typography style={{ paddingLeft: "9px" }} className={classes.TittleSmall}>{' (' + categories.length + ')'}</Typography>
                                                    </Box>
                                                    <SearchGroup
                                                        permissions={isPermission}
                                                        pickerMode={pickerMode}
                                                        categoryId={category.id}
                                                        onFilter={onFilter}
                                                        getCategory={getCategory}
                                                        setSnackbarMessage={setMsgCopyOrMoveSnackbar}
                                                    />
                                                </Fragment>
                                            </Box>
                                        )
                                }
                                <Snackbar
                                    show={msgCopyOrMoveSnackbar.message.length > 0}
                                    message={msgCopyOrMoveSnackbar.message}
                                    boldText={msgCopyOrMoveSnackbar.boldText}
                                    onClose={() => setMsgCopyOrMoveSnackbar({ message: '', boldText: '' })}
                                />
                                <Snackbar
                                    show={timeoutDelete.timeoutId !== null}
                                    message={translate('pos.categories.deleted')}
                                    undo={onUndoDelete}
                                    onClose={() => setTimeoutDelete({ timeoutId: null, ids: [] })}
                                />
                                {
                                    hasPermission === true ?
                                        <Box>
                                            <Box display='flex' justifyContent='center'>
                                                <img alt='' src={icSupport} />
                                            </Box>
                                            <Box display='flex' justifyContent='center' mt={2}>
                                                <Typography className={classes.textNoPermission}>{translate(`pos.categories.access`)}</Typography>
                                            </Box>
                                        </Box>
                                        :
                                        <TableFiles
                                            permissions={isPermission}
                                            pickerMode={pickerMode}
                                            searchEmpty={searchEmpty}
                                            categories={categories}
                                            onClear={onClear}
                                            getCategory={getCategory}
                                            setSnackbarMessage={setMsgCopyOrMoveSnackbar}
                                            onCheck={onCheck}
                                            onDelete={onDelete}
                                            onDownload={onDownload}
                                            currentId={category.id}
                                            level={category.level}
                                            onSortable={onSortable}
                                            loading={loading}
                                        />
                                }
                            </DialogContent>
                            {
                                category.level !== 2 && pickerMode !== 'menu' && <DialogActions style={{ paddingRight: 36, paddingTop: 8 }}>
                                    <Box hidden={hasPermission === true} >
                                        <Button color='primary' onClick={handleClose}>{translate(`pos.common.cancel`)}</Button>
                                        <Button
                                            variant='contained'
                                            color='primary'
                                            style={{ marginLeft: 8 }}
                                            onClick={chooseFile}
                                            disabled={category.categories && category.categories.filter(value => value.checked === true).length === 0}
                                        >{translate('pos.common.choose')}</Button>
                                        <Dialog open={openPickError} onClose={() => { setOpenPickError(false) }}>
                                            <Paper style={{ padding: '8px 16px' }}>
                                                <Box>
                                                    <Typography style={{ color: 'red', fontWeight: 'bold', marginBottom: 8 }}>{translate('pos.common.error')}</Typography>
                                                    <Typography style={{ color: 'red' }}>{translate('pos.categories.onlyOne')}</Typography>
                                                    <Box width='100%' display='flex' justifyContent='flex-end' mt={2}>
                                                        <Button onClick={() => { setOpenPickError(false) }} variant='contained' color='primary'>{translate('pos.user.ok')}</Button>
                                                    </Box>
                                                </Box>

                                            </Paper>
                                        </Dialog>
                                    </Box>
                                </DialogActions>
                            }

                        </Paper>
                    )
            }
        </Dialog>

    );
}
